import React, { useState, useEffect } from 'react'
import Header from './components/header'
import Logo from './components/header/logo'
import MainMenu from './components/header/main-menu'
import Footer from './components/footer'
import Copyright from './components/footer/copyright'
import Main from './components/main'
import Banner from './components/main/banner'
import AboutSection from './components/main/about'
import ServicesSection from './components/main/what-to-do'
import ResumeSection from './components/main/resume'
import ContactSection from './components/main/contact'
import ThankYou from './components/main/contact/thank-you'
import Meta from './components/common/Meta'

const App = () => {
  const [showThankYou, setShowThankYou] = useState(false);
  const [currentSection, setCurrentSection] = useState('home');

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const scrollHomeToTop = () => {
      const hash = window.location.hash.replace('#', '');
      if (hash === '' || hash === 'home') {
        window.scrollTo(0, 0);
      }
    };

    scrollHomeToTop();
    window.addEventListener('pageshow', scrollHomeToTop);

    return () => {
      window.removeEventListener('pageshow', scrollHomeToTop);
    };
  }, []);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace('#', '');

      if (hash === '') {
        setCurrentSection('home');
      } else if (hash === 'about') {
        setCurrentSection('about');
      } else if (hash === 'what-to-do') {
        setCurrentSection('services');
      } else if (hash === 'resume') {
        setCurrentSection('resume');
      } else if (hash === 'contact') {
        setCurrentSection('contact');
      }
    };

    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);
  
  useEffect(() => {
    const checkSuccess = () => {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('success') === 'true') {
        setShowThankYou(true);
        const timer = setTimeout(() => {
          setShowThankYou(false);
          window.history.replaceState({}, document.title, window.location.pathname);
        }, 5000);
        
        return () => clearTimeout(timer);
      }
    };
    checkSuccess();
    window.addEventListener('popstate', checkSuccess);
    
    return () => {
      window.removeEventListener('popstate', checkSuccess);
    };
  }, []);
  
  return (
    <>
      <Meta section={currentSection} />
      
      <Header>
        <Logo/>
        <MainMenu/>
      </Header>

      <Main>
        {showThankYou ? (
          <ThankYou />
        ) : (
          <>
            <Banner/>
            <div className="landing-row">
              <ServicesSection/>
              <AboutSection/>
            </div>
            <ResumeSection/>
            <ContactSection/>
          </>
        )}
      </Main>

      <Footer>
        <Copyright/>
      </Footer>
    </>
  )
}

export default App